<template>
  <!-- <TopNav/> -->
  <Banner/>
  <T1/>
  <T2/>
  <T3/>
  <T4/>
  <T5/>
  <T6/>

  <Footer/>
</template>

<script>
// import TopNav from './TopNav.vue'
import Banner from './Banner.vue'
import Footer from './Footer.vue'
import T1 from './t1.vue'
import T2 from './t2.vue'
import T3 from './t3.vue'
import T4 from './t4.vue'
import T5 from './t5.vue'
import T6 from './t6.vue'

export default {
  name: 'Main',
  components:{
    // TopNav,
    Footer,
    Banner,
    T1,
    T2,
    T3,
    T4,
    T5,
    T6

  }
}
</script>

<style >
*{margin: 0 ;padding: 0;} 
a{ text-decoration: none;}
li { list-style: none;}
#app{overflow: hidden;}
.juzhon{width: 1200px;margin: 0 auto;}
</style>
